import { createSlice } from "@reduxjs/toolkit";

import { fetchJobsData } from "../api/events.api";

import { companyNumbersConfig } from "../../configs/companyNumbersConfig";

export const defaultStateEvents = {
  numbers: companyNumbersConfig,
  jobsData: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      per_page: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  jobData: {
    data: null,
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
};

const events = createSlice({
  name: "events",
  initialState: defaultStateEvents,
  reducers: {
    setJobData: (state, action) => {
      return {
        ...state,
        jobData: {
          ...state.jobData,
          data: action.payload,
        },
      };
    },
  },
  extraReducers: (builder) => {
    // jobs start
    builder.addCase(fetchJobsData.pending, (state) => {
      return {
        ...state,
        jobsData: {
          ...state.jobsData,
          isLoading: true,
          isError: false,
          errorMessage: "",
        },
      };
    });
    builder.addCase(fetchJobsData.rejected, (state, action) => {
      return {
        ...state,
        jobsData: {
          ...state.jobsData,
          isLoading: false,
          isError: true,
          errorMessage: action.payload?.message,
        },
      };
    });
    builder.addCase(fetchJobsData.fulfilled, (state, action) => {
      return {
        ...state,
        jobsData: {
          ...state.jobsData,
          data: action.payload,
          isLoading: false,
          isError: false,
          errorMessage: "",
        },
      };
    });
    // jobs end
  },
});

export const { setJobData } = events.actions;

export default events.reducer;
